<div class="snack-text-container">
    <!-- <mat-icon *ngIf="type == 'success'" svgIcon="check" class="snack-icon"></mat-icon> -->
    <img *ngIf="type == 'success'" src="../../../../../assets/images/modals/hand-susccess.png" />
    <img *ngIf="type == 'error'" src="../../../../../assets/images/modals/hand-confirm.png" />
    <span class="snack-text">{{message}}</span>
</div>